var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "big" },
    [
      _c(
        "el-card",
        { staticClass: "my-card", attrs: { header: "商户信息" } },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12, sm: 12 } }, [
                _c("div", { staticClass: "grid-content" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("商户id ")]),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      _vm._s(_vm.$store.getters["user/userInfo"].merchantId)
                    ),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 12, sm: 12 } }, [
                _c("div", { staticClass: "grid-content" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("商户名称 ")]),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      _vm._s(_vm.$store.getters["user/userInfo"].nickName)
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c("el-col", { attrs: { span: 12, sm: 12 } }, [
            _c("div", { staticClass: "grid-content" }, [
              _c("span", { staticClass: "label" }, [_vm._v("登录账户 ")]),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.$store.getters["user/userInfo"].userName)),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }